"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  "use strict";
  function e() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
      var t = 16 * Math.random() | 0;return ("x" === e ? t : 3 & t | 8).toString(16);
    });
  }var t, r, n;!function (e) {
    e.AJAX_ERROR = "ajax", e.RESOURCE_ERROR = "resource", e.VUE_ERROR = "vue", e.PROMISE_ERROR = "promise", e.JS_ERROR = "js", e.UNKNOWN_ERROR = "unknown";
  }(t || (t = {})), function (e) {
    e.INFO = "Info", e.WARNING = "Warning", e.ERROR = "Error";
  }(r || (r = {})), function (e) {
    e.ERROR = "/browser/errorLog", e.ERRORS = "/browser/errorLogs", e.PERF = "/browser/perfData", e.SEGMENT = "/v3/segment", e.SEGMENTS = "/v3/segments";
  }(n || (n = {}));var o,
      i = "Http",
      a = "Exit";!function (e) {
    e[e.OPENED = 1] = "OPENED", e[e.DONE = 4] = "DONE";
  }(o || (o = {}));var s = 10001,
      c = "<browser>";var u = function () {
    function e(e, t) {
      this.url = "", "ERROR" === e ? this.url = t + n.ERROR : "ERRORS" === e ? this.url = t + n.ERRORS : "SEGMENT" === e ? this.url = t + n.SEGMENT : "SEGMENTS" === e ? this.url = t + n.SEGMENTS : "PERF" === e && (this.url = t + n.PERF);
    }return e.prototype.sendByFetch = function (e) {
      if (delete e.collector, this.url) {
        var t = new Request(this.url, { method: "POST", body: JSON.stringify(e) });fetch(t).then(function (e) {
          if (e.status >= 400 || 0 === e.status) throw new Error("Something went wrong on api server!");
        }).catch(function (e) {
          console.error(e);
        });
      }
    }, e.prototype.sendByXhr = function (e) {
      if (this.url) {
        var t = new XMLHttpRequest();t.open("post", this.url, !0), t.setRequestHeader("Content-Type", "application/json"), t.onreadystatechange = function () {
          4 === t.readyState && t.status < 400 && console.log("Report successfully");
        }, t.send(JSON.stringify(e));
      }
    }, e;
  }(),
      l = new (function () {
    function e() {
      this.queues = [], this.collector = "";
    }return e.prototype.addTask = function (e, t) {
      this.queues.push(e), this.collector = t;
    }, e.prototype.fireTasks = function () {
      this.queues && this.queues.length && (new u("ERRORS", this.collector).sendByXhr(this.queues), this.queues = []);
    }, e.prototype.finallyFireTasks = function () {
      var e = this;window.onbeforeunload = function () {
        e.queues.length && new u("ERRORS", e.collector).sendByXhr(e.queues);
      };
    }, e;
  }())();var f,
      p = {};var h = function () {
    function e() {
      this.logInfo = { uniqueId: "", service: "", serviceVersion: "", pagePath: "", category: t.UNKNOWN_ERROR, grade: r.INFO, errorUrl: "", line: 0, col: 0, message: "", firstReportedError: !1, collector: "" };
    }return e.prototype.traceInfo = function (e) {
      var r;this.logInfo = e || this.logInfo;var n = [t.AJAX_ERROR, t.RESOURCE_ERROR, t.UNKNOWN_ERROR];p[location.href] || n.includes(this.logInfo.category) || ((r = {})[location.href] = !0, p = r, this.logInfo.firstReportedError = !0);var o = this.logInfo.collector;delete this.logInfo.collector, l.addTask(this.logInfo, o), l.finallyFireTasks(), f || (f = setInterval(function () {
        l.fireTasks();
      }, 6e4));
    }, e;
  }();var _g,
      d = (_g = function g(e, t) {
    return (_g = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var r in t) {
        t.hasOwnProperty(r) && (e[r] = t[r]);
      }
    })(e, t);
  }, function (e, t) {
    function r() {
      this.constructor = e;
    }_g(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
  });var v = new (function (n) {
    function o() {
      return null !== n && n.apply(this, arguments) || this;
    }return d(o, n), o.prototype.handleErrors = function (n) {
      var o = this;window.onerror = function (i, a, s, c, u) {
        o.logInfo = { uniqueId: e(), service: n.service, serviceVersion: n.serviceVersion, pagePath: n.pagePath, category: t.JS_ERROR, grade: r.ERROR, errorUrl: a, line: s, col: c, message: i, collector: n.collector, stack: u ? u.stack : "" }, o.traceInfo();
      };
    }, o;
  }(h))();var m = function () {
    var _e = function e(t, r) {
      return (_e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) {
          t.hasOwnProperty(r) && (e[r] = t[r]);
        }
      })(t, r);
    };return function (t, r) {
      function n() {
        this.constructor = t;
      }_e(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
  }();var y = new (function (n) {
    function o() {
      return null !== n && n.apply(this, arguments) || this;
    }return m(o, n), o.prototype.handleErrors = function (n) {
      var o = this;window.addEventListener("unhandledrejection", function (i) {
        try {
          var a = "";if (!i || !i.reason) return;i.reason.config && i.reason.config.url && (a = i.reason.config.url), o.logInfo = { uniqueId: e(), service: n.service, serviceVersion: n.serviceVersion, pagePath: n.pagePath, category: t.PROMISE_ERROR, grade: r.ERROR, errorUrl: a || location.href, message: i.reason.message, stack: i.reason.stack, collector: n.collector }, o.traceInfo();
        } catch (e) {
          console.log(e);
        }
      });
    }, o;
  }(h))();var R = function () {
    var _e2 = function e(t, r) {
      return (_e2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) {
          t.hasOwnProperty(r) && (e[r] = t[r]);
        }
      })(t, r);
    };return function (t, r) {
      function n() {
        this.constructor = t;
      }_e2(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
  }();var E = new (function (o) {
    function i() {
      return null !== o && o.apply(this, arguments) || this;
    }return R(i, o), i.prototype.handleError = function (o) {
      var i = this;window.XMLHttpRequest && window.addEventListener("xhrReadyStateChange", function (a) {
        var s = a.detail;4 === s.readyState && s.getRequestConfig[1] !== o.collector + n.ERRORS && (0 !== s.status && s.status < 400 || (i.logInfo = { uniqueId: e(), service: o.service, serviceVersion: o.serviceVersion, pagePath: o.pagePath, category: t.AJAX_ERROR, grade: r.ERROR, errorUrl: s.getRequestConfig[1], message: "status: " + s.status + "; statusText: " + s.statusText + ";", collector: o.collector, stack: s.responseText }, i.traceInfo()));
      });
    }, i;
  }(h))();var w = function () {
    var _e3 = function e(t, r) {
      return (_e3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) {
          t.hasOwnProperty(r) && (e[r] = t[r]);
        }
      })(t, r);
    };return function (t, r) {
      function n() {
        this.constructor = t;
      }_e3(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
  }();var S = new (function (n) {
    function o() {
      return null !== n && n.apply(this, arguments) || this;
    }return w(o, n), o.prototype.handleErrors = function (n) {
      var o = this;window.addEventListener("error", function (i) {
        try {
          if (!i) return;var a = i.target || i.srcElement;if (!(a instanceof HTMLScriptElement || a instanceof HTMLLinkElement || a instanceof HTMLImageElement)) return;o.logInfo = { uniqueId: e(), service: n.service, serviceVersion: n.serviceVersion, pagePath: n.pagePath, category: t.RESOURCE_ERROR, grade: "IMG" === a.tagName ? r.WARNING : r.ERROR, errorUrl: a.src || a.href || location.href, message: "load " + a.tagName + " resource error", collector: n.collector, stack: "load " + a.tagName + " resource error" }, o.traceInfo();
        } catch (e) {
          throw e;
        }
      });
    }, o;
  }(h))();var O = function () {
    var _e4 = function e(t, r) {
      return (_e4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) {
          t.hasOwnProperty(r) && (e[r] = t[r]);
        }
      })(t, r);
    };return function (t, r) {
      function n() {
        this.constructor = t;
      }_e4(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
  }();var b = new (function (n) {
    function o() {
      return null !== n && n.apply(this, arguments) || this;
    }return O(o, n), o.prototype.handleErrors = function (n, o) {
      var i = this;o.config.errorHandler = function (o, a, s) {
        try {
          i.logInfo = { uniqueId: e(), service: n.service, serviceVersion: n.serviceVersion, pagePath: n.pagePath, category: t.VUE_ERROR, grade: r.ERROR, errorUrl: location.href, message: s, collector: n.collector, stack: o.stack }, i.traceInfo();
        } catch (o) {
          throw o;
        }
      };
    }, o;
  }(h))();var I = function () {
    var _e5 = function e(t, r) {
      return (_e5 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) {
          t.hasOwnProperty(r) && (e[r] = t[r]);
        }
      })(t, r);
    };return function (t, r) {
      function n() {
        this.constructor = t;
      }_e5(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
  }();var T = new (function (n) {
    function o() {
      return null !== n && n.apply(this, arguments) || this;
    }return I(o, n), o.prototype.handleErrors = function (n, o) {
      this.logInfo = { uniqueId: e(), service: n.service, serviceVersion: n.serviceVersion, pagePath: n.pagePath, category: t.JS_ERROR, grade: r.ERROR, errorUrl: o.name || location.href, message: o.message, collector: n.collector || location.origin, stack: o.stack }, this.traceInfo();
    }, o;
  }(h))(),
      P = function () {
    function e() {}return e.prototype.getPerfTiming = function () {
      try {
        var e = window.performance.timing;if ("function" == typeof window.PerformanceNavigationTiming) {
          var t = performance.getEntriesByType("navigation")[0];t && (e = t);
        }return { redirectTime: void 0 !== e.navigationStart ? parseInt(String(e.fetchStart - e.navigationStart), 10) : void 0 !== e.redirectEnd ? parseInt(String(e.redirectEnd - e.redirectStart), 10) : 0, dnsTime: parseInt(String(e.domainLookupEnd - e.domainLookupStart), 10), ttfbTime: parseInt(String(e.responseStart - e.requestStart), 10), tcpTime: parseInt(String(e.connectEnd - e.connectStart), 10), transTime: parseInt(String(e.responseEnd - e.responseStart), 10), domAnalysisTime: parseInt(String(e.domInteractive - e.responseEnd), 10), fptTime: parseInt(String(e.responseEnd - e.fetchStart), 10), domReadyTime: parseInt(String(e.domContentLoadedEventEnd - e.fetchStart), 10), loadPageTime: parseInt(String(e.loadEventStart - e.fetchStart), 10), resTime: parseInt(String(e.loadEventStart - e.domContentLoadedEventEnd), 10), sslTime: "https:" === location.protocol && e.secureConnectionStart > 0 ? parseInt(String(e.connectEnd - e.secureConnectionStart), 10) : void 0, ttlTime: parseInt(String(e.domInteractive - e.fetchStart), 10), firstPackTime: parseInt(String(e.responseStart - e.domainLookupStart), 10), fmpTime: 0 };
      } catch (e) {
        throw e;
      }
    }, e;
  }();var _,
      x = function x(e, t) {
    return window.getComputedStyle ? window.getComputedStyle(e, null)[t] : e.currentStyle[t];
  };!function (e) {
    e[e.SVG = 2] = "SVG", e[e.IMG = 2] = "IMG", e[e.CANVAS = 4] = "CANVAS", e[e.OBJECT = 4] = "OBJECT", e[e.EMBED = 4] = "EMBED", e[e.VIDEO = 4] = "VIDEO";
  }(_ || (_ = {}));var C = performance.now(),
      N = ["SCRIPT", "STYLE", "META", "HEAD", "LINK"],
      k = window.innerWidth,
      A = window.innerHeight;var L = function () {
    function e() {
      this.fmpTime = 0, this.statusCollector = [], this.flag = !0, this.observer = null, this.callbackCount = 0, this.entries = {}, performance && performance.getEntries ? this.initObserver() : console.log("your browser do not support performance.getEntries");
    }return e.prototype.getFirstSnapShot = function () {
      var e = performance.now(),
          t = document.body;t && this.setTag(t, this.callbackCount), this.statusCollector.push({ time: e });
    }, e.prototype.initObserver = function () {
      var e = this;this.getFirstSnapShot(), this.observer = new MutationObserver(function () {
        e.callbackCount += 1;var t = performance.now(),
            r = document.body;r && e.setTag(r, e.callbackCount), e.statusCollector.push({ time: t });
      }), this.observer.observe(document, { childList: !0, subtree: !0 }), "complete" === document.readyState ? this.calculateFinalScore() : window.addEventListener("load", function () {
        e.calculateFinalScore();
      }, !1);
    }, e.prototype.calculateFinalScore = function () {
      var e = this;if (MutationEvent && this.flag) if (this.checkNeedCancel(C)) {
        this.observer.disconnect(), this.flag = !1;for (var t = null, r = 0, n = this.getTreeScore(document.body).dpss; r < n.length; r++) {
          var o = n[r];t && t.st ? t.st < o.st && (t = o) : t = o;
        }if (performance.getEntries().forEach(function (t) {
          e.entries[t.name] = t.responseEnd;
        }), !t) return !1;var i = this.filterResult(t.els),
            a = this.getFmpTime(i);this.fmpTime = a;
      } else setTimeout(function () {
        e.calculateFinalScore();
      }, 500);
    }, e.prototype.getFmpTime = function (e) {
      for (var t = 0, r = 0, n = e; r < n.length; r++) {
        var o = n[r],
            i = 0;if (1 === o.weight) {
          var a = parseInt(o.ele.getAttribute("fmp_c"), 10);i = this.statusCollector[a].time;
        } else if (2 === o.weight) {
          if ("IMG" === o.ele.tagName) i = this.entries[o.ele.src];else if ("SVG" === o.ele.tagName) a = parseInt(o.ele.getAttribute("fmp_c"), 10), i = this.statusCollector[a].time;else {
            var s = x(o.ele, "background-image").match(/url\(\"(.*?)\"\)/),
                c = void 0;s && s[1] && (c = s[1]), c.includes("http") || (c = location.protocol + s[1]), i = this.entries[c];
          }
        } else 4 === o.weight && ("CANVAS" === o.ele.tagName ? (a = parseInt(o.ele.getAttribute("fmp_c"), 10), i = this.statusCollector[a] && this.statusCollector[a].time) : "VIDEO" === o.ele.tagName && ((i = this.entries[o.ele.src]) || (i = this.entries[o.ele.poster])));"number" != typeof i && (i = 0), t < i && (t = i);
      }return t;
    }, e.prototype.filterResult = function (e) {
      if (1 === e.length) return e;var t = 0;e.forEach(function (e) {
        t += e.st;
      });var r = t / e.length;return e.filter(function (e) {
        return e.st > r;
      });
    }, e.prototype.checkNeedCancel = function (e) {
      var t = performance.now() - e,
          r = this.statusCollector.length > 0 ? this.statusCollector[this.statusCollector.length - 1].time : 0;return t > 3e3 || t - r > 1e3;
    }, e.prototype.getTreeScore = function (e) {
      if (!e) return {};for (var t = [], r = 0, n = e.children; r < n.length; r++) {
        var o = n[r];if (o.getAttribute("fmp_c")) {
          var i = this.getTreeScore(o);i.st && t.push(i);
        }
      }return this.calcaulteGrades(e, t);
    }, e.prototype.calcaulteGrades = function (e, t) {
      var r = e.getBoundingClientRect(),
          n = r.width,
          o = r.height,
          i = r.left,
          a = r.top,
          s = !0;(A < a || k < i) && (s = !1);var c = 0;t.forEach(function (e) {
        c += e.st;
      });var u = Number(_[e.tagName]) || 1;1 === u && x(e, "background-image") && "initial" !== x(e, "background-image") && "none" !== x(e, "background-image") && (u = _.IMG);var l = s ? n * o * u : 0,
          f = [{ ele: e, st: l, weight: u }],
          p = e,
          h = this.calculateAreaParent(e);if (c > l * h || 0 === h) {
        l = c, f = [];for (var g = 0, d = t; g < d.length; g++) {
          var v = d[g];f = f.concat(v.els);
        }
      }return { dpss: t, st: l, els: f, root: p };
    }, e.prototype.calculateAreaParent = function (e) {
      var t = e.getBoundingClientRect(),
          r = t.left,
          n = t.right,
          o = t.top,
          i = t.bottom,
          a = t.width,
          s = t.height,
          c = k,
          u = A,
          l = n - r + (c - 0) - (Math.max(n, c) - Math.min(r, 0)),
          f = i - o + (u - 0) - (Math.max(i, u) - Math.min(o, 0));return l <= 0 || f <= 0 ? 0 : l * f / (a * s);
    }, e.prototype.setTag = function (e, t) {
      var r = e.tagName;if (-1 === N.indexOf(r)) {
        var n = e.children;if (n && n.length > 0) for (var o = n.length - 1; o >= 0; o--) {
          var i = n[o];if (null === i.getAttribute("fmp_c")) {
            var a = i.getBoundingClientRect(),
                s = a.left,
                c = a.top,
                u = a.width,
                l = a.height;if (A < c || k < s || 0 === u || 0 === l) continue;i.setAttribute("fmp_c", "" + t);
          }this.setTag(i, t);
        }
      }
    }, e;
  }();var _M = function M() {
    return (_M = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) {
        for (var o in t = arguments[r]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }return e;
    }).apply(this, arguments);
  };var V = new (function () {
    function e() {
      this.perfConfig = { perfDetail: {} };
    }return e.prototype.recordPerf = function (e) {
      return t = this, r = void 0, o = function o() {
        var t,
            r,
            n = this;return function (e, t) {
          var r,
              n,
              o,
              i,
              a = { label: 0, sent: function sent() {
              if (1 & o[0]) throw o[1];return o[1];
            }, trys: [], ops: [] };return i = { next: s(0), throw: s(1), return: s(2) }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
            return this;
          }), i;function s(i) {
            return function (s) {
              return function (i) {
                if (r) throw new TypeError("Generator is already executing.");for (; a;) {
                  try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {case 0:case 1:
                        o = i;break;case 4:
                        return a.label++, { value: i[1], done: !1 };case 5:
                        a.label++, n = i[1], i = [0];continue;case 7:
                        i = a.ops.pop(), a.trys.pop();continue;default:
                        if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                          a = 0;continue;
                        }if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                          a.label = i[1];break;
                        }if (6 === i[0] && a.label < o[1]) {
                          a.label = o[1], o = i;break;
                        }if (o && a.label < o[2]) {
                          a.label = o[2], a.ops.push(i);break;
                        }o[2] && a.ops.pop(), a.trys.pop();continue;}i = t.call(e, a);
                  } catch (e) {
                    i = [6, e], n = 0;
                  } finally {
                    r = o = 0;
                  }
                }if (5 & i[0]) throw i[1];return { value: i[0] ? i[1] : void 0, done: !0 };
              }([i, s]);
            };
          }
        }(this, function (o) {
          switch (o.label) {case 0:
              return t = { fmpTime: void 0 }, e.autoTracePerf ? (r = this.perfConfig, [4, new P().getPerfTiming()]) : [3, 3];case 1:
              return r.perfDetail = o.sent(), e.useFmp ? [4, new L()] : [3, 3];case 2:
              t = o.sent(), o.label = 3;case 3:
              return setTimeout(function () {
                var r = e.autoTracePerf ? _M(_M({}, n.perfConfig.perfDetail), { fmpTime: e.useFmp ? parseInt(String(t.fmpTime), 10) : void 0 }) : void 0,
                    o = _M(_M({}, r), { pagePath: e.pagePath, serviceVersion: e.serviceVersion, service: e.service });new u("PERF", e.collector).sendByXhr(o), n.clearPerf();
              }, 6e3), [2];}
        });
      }, new ((n = void 0) || (n = Promise))(function (e, i) {
        function a(e) {
          try {
            c(o.next(e));
          } catch (e) {
            i(e);
          }
        }function s(e) {
          try {
            c(o.throw(e));
          } catch (e) {
            i(e);
          }
        }function c(t) {
          var r;t.done ? e(t.value) : (r = t.value, r instanceof n ? r : new n(function (e) {
            e(r);
          })).then(a, s);
        }c((o = o.apply(t, r || [])).next());
      });var t, r, n, o;
    }, e.prototype.clearPerf = function () {
      window.performance && window.performance.clearResourceTimings && (window.performance.clearResourceTimings(), this.perfConfig = { perfDetail: {} });
    }, e;
  }())(),
      q = "function" == typeof btoa,
      D = "function" == typeof Buffer,
      F = ("function" == typeof TextDecoder && new TextDecoder(), "function" == typeof TextEncoder ? new TextEncoder() : void 0),
      U = [].concat(_toConsumableArray("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=")),
      j = (function (e) {
    var t = {};e.forEach(function (e, r) {
      return t[e] = r;
    });
  }(U), String.fromCharCode.bind(String)),
      G = ("function" == typeof Uint8Array.from && Uint8Array.from.bind(Uint8Array), function (e) {
    return e.replace(/[+\/]/g, function (e) {
      return "+" == e ? "-" : "_";
    }).replace(/=+$/m, "");
  }),
      B = q ? function (e) {
    return btoa(e);
  } : D ? function (e) {
    return Buffer.from(e, "binary").toString("base64");
  } : function (e) {
    var t = void 0,
        r = void 0,
        n = void 0,
        o = void 0,
        i = "";var a = e.length % 3;for (var _a = 0; _a < e.length;) {
      if ((r = e.charCodeAt(_a++)) > 255 || (n = e.charCodeAt(_a++)) > 255 || (o = e.charCodeAt(_a++)) > 255) throw new TypeError("invalid character found");t = r << 16 | n << 8 | o, i += U[t >> 18 & 63] + U[t >> 12 & 63] + U[t >> 6 & 63] + U[63 & t];
    }return a ? i.slice(0, a - 3) + "===".substring(a) : i;
  },
      X = D ? function (e) {
    return Buffer.from(e).toString("base64");
  } : function (e) {
    var t = [];for (var _r = 0, _n = e.length; _r < _n; _r += 4096) {
      t.push(j.apply(null, e.subarray(_r, _r + 4096)));
    }return B(t.join(""));
  },
      H = function H(e) {
    if (e.length < 2) return (t = e.charCodeAt(0)) < 128 ? e : t < 2048 ? j(192 | t >>> 6) + j(128 | 63 & t) : j(224 | t >>> 12 & 15) + j(128 | t >>> 6 & 63) + j(128 | 63 & t);var t = 65536 + 1024 * (e.charCodeAt(0) - 55296) + (e.charCodeAt(1) - 56320);return j(240 | t >>> 18 & 7) + j(128 | t >>> 12 & 63) + j(128 | t >>> 6 & 63) + j(128 | 63 & t);
  },
      W = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g,
      J = D ? function (e) {
    return Buffer.from(e, "utf8").toString("base64");
  } : F ? function (e) {
    return X(F.encode(e));
  } : function (e) {
    return B(e.replace(W, H));
  },
      K = function K(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return t ? G(J(e)) : J(e);
  };var _Y = function Y() {
    return (_Y = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) {
        for (var o in t = arguments[r]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }return e;
    }).apply(this, arguments);
  };function z(t, r) {
    var u = window.XMLHttpRequest,
        l = XMLHttpRequest.prototype.send,
        f = XMLHttpRequest.prototype.open;function p(e) {
      var t = new CustomEvent(e, { detail: this });window.dispatchEvent(t);
    }u.getRequestConfig = [], window.XMLHttpRequest = function () {
      var e = new u();return e.addEventListener("readystatechange", function () {
        p.call(this, "xhrReadyStateChange");
      }, !1), e.open = function (e, t, r, n, o) {
        return this.getRequestConfig = arguments, f.apply(this, arguments);
      }, e.send = function (e) {
        return l.apply(this, arguments);
      }, e;
    };var h = [];window.addEventListener("xhrReadyStateChange", function (u) {
      var l = { traceId: "", service: t.service + c, spans: [], serviceInstance: t.serviceVersion, traceSegmentId: "" },
          f = u.detail.readyState,
          p = u.detail.getRequestConfig,
          g = {};if (p[1].startsWith("http://") || p[1].startsWith("https://") ? g = new URL(p[1]) : p[1].startsWith("//") ? g = new URL("" + window.location.protocol + p[1]) : (g = new URL(window.location.href)).pathname = p[1], !t.noTraceOrigins.some(function (e) {
        if ("string" == typeof e) {
          if (e === g.origin) return !0;
        } else if (e instanceof RegExp && e.test(g.origin)) return !0;
      })) {
        var d = new URL(t.collector),
            v = "/" === d.pathname ? g.pathname : g.pathname.replace(new RegExp("^" + d.pathname), "");if (![n.ERROR, n.ERRORS, n.PERF, n.SEGMENTS].includes(v) || t.traceSDKInternal) {
          if (f === o.OPENED) {
            var m = e(),
                y = e();h.push({ event: u.detail, startTime: new Date().getTime(), traceId: m, traceSegmentId: y });var R = String(K(m)),
                E = String(K(y)),
                w = String(K(l.service)),
                S = String(K(l.serviceInstance)),
                O = String(K(t.pagePath)),
                b = String(K(g.host)),
                I = "1-" + R + "-" + E + "-" + l.spans.length + "-" + w + "-" + S + "-" + O + "-" + b;u.detail.setRequestHeader("sw8", I);
          }if (f === o.DONE) {
            for (var T = new Date().getTime(), P = 0; P < h.length; P++) {
              if (h[P].event.readyState === o.DONE) {
                var _ = {};h[P].event.status && (_ = new URL(h[P].event.responseURL));var x = { operationName: t.pagePath, startTime: h[P].startTime, endTime: T, spanId: l.spans.length, spanLayer: i, spanType: a, isError: 0 === u.detail.status || u.detail.status >= 400, parentSpanId: l.spans.length - 1, componentId: s, peer: _.host, tags: t.detailMode ? [{ key: "http.method", value: p[0] }, { key: "url", value: h[P].event.responseURL || g.protocol + "//" + g.host + g.pathname }] : void 0 };(l = _Y(_Y({}, l), { traceId: h[P].traceId, traceSegmentId: h[P].traceSegmentId })).spans.push(x), h.splice(P, 1);
              }
            }r.push(l);
          }
        }
      }
    });
  }var _Q = function Q() {
    return (_Q = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) {
        for (var o in t = arguments[r]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }return e;
    }).apply(this, arguments);
  },
      Z = function Z(e, t, r, n) {
    return new (r || (r = Promise))(function (o, i) {
      function a(e) {
        try {
          c(n.next(e));
        } catch (e) {
          i(e);
        }
      }function s(e) {
        try {
          c(n.throw(e));
        } catch (e) {
          i(e);
        }
      }function c(e) {
        var t;e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
          e(t);
        })).then(a, s);
      }c((n = n.apply(e, t || [])).next());
    });
  },
      $ = function $(e, t) {
    var r,
        n,
        o,
        i,
        a = { label: 0, sent: function sent() {
        if (1 & o[0]) throw o[1];return o[1];
      }, trys: [], ops: [] };return i = { next: s(0), throw: s(1), return: s(2) }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
      return this;
    }), i;function s(i) {
      return function (s) {
        return function (i) {
          if (r) throw new TypeError("Generator is already executing.");for (; a;) {
            try {
              if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {case 0:case 1:
                  o = i;break;case 4:
                  return a.label++, { value: i[1], done: !1 };case 5:
                  a.label++, n = i[1], i = [0];continue;case 7:
                  i = a.ops.pop(), a.trys.pop();continue;default:
                  if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                    a = 0;continue;
                  }if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                    a.label = i[1];break;
                  }if (6 === i[0] && a.label < o[1]) {
                    a.label = o[1], o = i;break;
                  }if (o && a.label < o[2]) {
                    a.label = o[2], a.ops.push(i);break;
                  }o[2] && a.ops.pop(), a.trys.pop();continue;}i = t.call(e, a);
            } catch (e) {
              i = [6, e], n = 0;
            } finally {
              r = o = 0;
            }
          }if (5 & i[0]) throw i[1];return { value: i[0] ? i[1] : void 0, done: !0 };
        }([i, s]);
      };
    }
  };var _ee = function ee() {
    return (_ee = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) {
        for (var o in t = arguments[r]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }return e;
    }).apply(this, arguments);
  };var te = { customOptions: { collector: location.origin, jsErrors: !0, apiErrors: !0, resourceErrors: !0, autoTracePerf: !0, useFmp: !1, enableSPA: !1, traceSDKInternal: !1, detailMode: !0, noTraceOrigins: [], traceTimeInterval: 6e4 }, register: function register(o) {
      var l, f;this.customOptions = _ee(_ee({}, this.customOptions), o), this.catchErrors(this.customOptions), this.customOptions.enableSPA || this.performance(this.customOptions), z(l = this.customOptions, f = []), function (o, u) {
        var l = this,
            f = window.fetch;window.fetch = function () {
          for (var p = [], g = 0; g < arguments.length; g++) {
            p[g] = arguments[g];
          }return Z(l, void 0, void 0, function () {
            var l, g, d, v, m, y, R, E, w, S, O, b, I, T, P, _, x, C, N, k, A, L, M;return $(this, function (V) {
              switch (V.label) {case 0:
                  return l = new Date().getTime(), g = e(), d = e(), v = { traceId: "", service: o.service + c, spans: [], serviceInstance: o.serviceVersion, traceSegmentId: "" }, m = {}, p[0].startsWith("http://") || p[0].startsWith("https://") ? m = new URL(p[0]) : p[0].startsWith("//") ? m = new URL("" + window.location.protocol + p[0]) : (m = new URL(window.location.href)).pathname = p[0], y = o.noTraceOrigins.some(function (e) {
                    if ("string" == typeof e) {
                      if (e === m.origin) return !0;
                    } else if (e instanceof RegExp && e.test(m.origin)) return !0;
                  }), R = new URL(o.collector), E = "/" === R.pathname ? m.pathname : m.pathname.replace(new RegExp("^" + R.pathname), ""), w = [n.ERROR, n.ERRORS, n.PERF, n.SEGMENTS], S = w.includes(E), (O = !y || S && o.traceSDKInternal) && (b = String(K(g)), I = String(K(d)), T = String(K(v.service)), P = String(K(v.serviceInstance)), _ = String(K(o.pagePath)), x = String(K(m.host)), C = v.spans.length, N = "1-" + b + "-" + I + "-" + C + "-" + T + "-" + P + "-" + _ + "-" + x, p[1] || (p[1] = {}), p[1].headers || (p[1].headers = {}), p[1].headers.sw8 = N), [4, f.apply(void 0, p)];case 1:
                  k = V.sent();try {
                    k && (0 === k.status || k.status >= 400) && (A = { uniqueId: e(), service: o.service, serviceVersion: o.serviceVersion, pagePath: o.pagePath, category: t.AJAX_ERROR, grade: r.ERROR, errorUrl: k && k.url || m.protocol + "//" + m.host + m.pathname, message: "status: " + (k ? k.status : 0) + "; statusText: " + (k && k.statusText) + ";", collector: o.collector, stack: "Fetch: " + k && k.statusText }, new h().traceInfo(A)), O && (L = new Date().getTime(), M = { operationName: o.pagePath, startTime: l, endTime: L, spanId: v.spans.length, spanLayer: i, spanType: a, isError: k && (0 === k.status || k.status >= 400), parentSpanId: v.spans.length - 1, componentId: s, peer: m.host, tags: o.detailMode ? [{ key: "http.method", value: p[1].method || "GET" }, { key: "url", value: k && k.url || m.protocol + "//" + m.host + m.pathname }] : void 0 }, (v = _Q(_Q({}, v), { traceId: g, traceSegmentId: d })).spans.push(M), u.push(v));
                  } catch (e) {
                    throw e;
                  }return [2, k.clone()];}
            });
          });
        };
      }(l, f), window.onbeforeunload = function (e) {
        f.length && new u("SEGMENTS", l.collector).sendByXhr(f);
      }, setInterval(function () {
        f.length && (new u("SEGMENTS", l.collector).sendByXhr(f), f.splice(0, f.length));
      }, l.traceTimeInterval);
    }, performance: function performance(e) {
      "complete" === document.readyState ? V.recordPerf(e) : window.addEventListener("load", function () {
        V.recordPerf(e);
      }, !1), this.customOptions.enableSPA && window.addEventListener("hashchange", function () {
        V.recordPerf(e);
      }, !1);
    }, catchErrors: function catchErrors(e) {
      var t = e.service,
          r = e.pagePath,
          n = e.serviceVersion,
          o = e.collector;e.jsErrors && (v.handleErrors({ service: t, pagePath: r, serviceVersion: n, collector: o }), y.handleErrors({ service: t, pagePath: r, serviceVersion: n, collector: o }), e.vue && b.handleErrors({ service: t, pagePath: r, serviceVersion: n, collector: o }, e.vue)), e.apiErrors && E.handleError({ service: t, pagePath: r, serviceVersion: n, collector: o }), e.resourceErrors && S.handleErrors({ service: t, pagePath: r, serviceVersion: n, collector: o });
    }, setPerformance: function setPerformance(e) {
      this.customOptions = _ee(_ee({}, this.customOptions), e), this.performance(this.customOptions);
    }, reportFrameErrors: function reportFrameErrors(e, t) {
      T.handleErrors(e, t);
    } };window.ClientMonitor = te;
})();